let loadedCarts = false;

const state = () => ({
    carts:[],
    item:{},
    items:[],
    cartsLoading:false,
    emptycarts:false,
    ids:[]
});

const mutations =
    {
        setCarts(state, items)
        {
            state.carts = items;
        },
        addNewCart(state,item)
        {
            state.carts.unshift(item)
        },
        setItem(state,item)
        {
            state.item = item
        },
        setItems(state,items)
        {
            state.items = items
        },
        setLoading(state,item)
        {
            state.cartsLoading = item;
        },
        setEmtpyCarts(state,item)
        {
            state.emptycarts = item
        },
        setIds(state,item)
        {
            state.ids = item
        }
    };

const actions =
    {
        loadCarts ({ commit,state })
        {
            if (!loadedCarts)
            {
                commit('setLoading',true)
                loadedCarts = true
                const request = $.ajax({
                    type: 'GET',
                    url: '/rest/cartsave/cart/getCartsByCustomerPlain/',
                    success: function (data)
                    {
                        let carts = data.carts;
                        for(let i = 0; i < carts.length; i++)
                        {
                            carts[i].addedBtnLoading     = false;
                            carts[i].loading             = false;
                            carts[i].waiting             = false;
                            carts[i].deleteBasketFirst   = false;
                            carts[i].items               = [];
                            if (typeof document !== 'undefined') {
                                carts[i].url = document.location.origin+'/spotlight/sharedcart/'+carts[i].cart_hash+'/';
                            } else {
                                carts[i].url = '/spotlight/sharedcart/'+carts[i].cart_hash+'/';
                            }
                            carts[i].cart_isPublic       = (carts[i].cart_isPublic == 1) ? true : false;
                            carts[i].overAllPrice        = 0;
                        }
                        if(carts.length === 0 )
                        {
                            commit('setEmtpyCarts',true)
                        }
                        commit('setCarts', carts)
                        commit('setIds', data.ids)
                        commit('setLoading',false)
                        loadedCarts = false
                    },
                    error: function (jqXHR, textStatus, errorThrown)
                    {
                        console.error(errorThrown)
                        commit('setLoading',false);
                        loadedCarts = false
                    }
                })
                return request
            }
        },
        addToItemToList({commit,state},cart)
        {
            let cartid = cart.id;
            cart.addedBtnLoading = true;
            let updateObj = {}
            for(let i = 0; i < state.carts.length; i++)
            {
                if(state.carts[i].id === cartid)
                {
                    let items = [];
                    if(state.items.length > 0)
                    {
                        for(let i2 = 0; i2 < state.items.length; i2++)
                        {
                            let quantityChanges = [];
                            for(let i3 = 0; i3 < state.carts[i].cart_variations.length; i3++)
                            {
                                if(parseInt(state.items[i2].id) === parseInt(state.carts[i].cart_variations[i3].id))
                                {
                                    state.carts[i].cart_variations[i3].quantity = parseFloat(state.carts[i].cart_variations[i3].quantity)+parseFloat(state.items[i2].quantity);
                                    quantityChanges.push(state.items[i2].id)
                                }
                            }
                            if(quantityChanges.indexOf(state.items[i2].id) === -1)
                            {
                                items.push(
                                    {
                                        "id"        : state.items[i2].id,
                                        "quantity"  : state.items[i2].quantity
                                    })
                            }
                        }
                        let newItems = state.carts[i].cart_variations.concat(items);
                        updateObj    =
                            {
                                "id"                 : state.carts[i].id,
                                "cart_name"          : state.carts[i].cart_name,
                                "cart_variations"    : newItems,
                                "cart_isPublic"      : state.carts[i].cart_isPublic,
                                "userId"             : 0
                            }
                    }
                    else
                    {
                        state.carts[i].cart_variations.push(state.item);
                        updateObj =
                            {
                                "id"                 : state.carts[i].id,
                                "cart_name"          : state.carts[i].cart_name,
                                "cart_variations"    : state.carts[i].cart_variations,
                                "cart_isPublic"      : state.carts[i].cart_isPublic,
                                "userId"             : 0,
                                "newItem"            :
                                    {
                                        "id"        : state.item.id,
                                        "quantity"  : state.item.quantity
                                    }
                            }
                    }
                    $.ajax({
                        type: 'POST',
                        url: '/rest/cartsave/cart/updateCart/',
                        dataType: "json",
                        data: updateObj,
                        success: function (data)
                        {
                            for(let d = 0; d < state.carts.length; d++)
                            {
                                if(parseInt(state.carts[d].id) === parseInt(data.cart.id))
                                {
                                    if (state.carts[d].items.length > 0)
                                    {
                                        if(state.items.length > 0)
                                        {
                                            for(let rp = 0; rp < state.items.length; rp++)
                                            {
                                                let exists = -1;
                                                let addQuantity = -1;
                                                for(let e = 0; e < state.carts[d].items.length; e++)
                                                {
                                                    if(parseInt(state.carts[d].items[e].id) === parseInt(state.items[rp].id))
                                                    {
                                                        exists = e;
                                                        addQuantity = state.items[rp].quantity
                                                    }
                                                }
                                                if(exists === -1)
                                                {
                                                    state.carts[d].items.unshift(state.items[rp]);
                                                }
                                                else
                                                {
                                                    state.carts[d].items[exists].quantity = parseFloat(state.carts[d].items[exists].quantity) + parseFloat(addQuantity)
                                                }
                                            }
                                        }
                                        else
                                        {
                                            let exists = -1;
                                            for(let s = 0; s < state.carts[d].items.length; s++)
                                            {
                                                if(parseInt(state.carts[d].items[s].id) === parseInt(data.item.id))
                                                {
                                                    exists = s;
                                                }
                                            }
                                            if(exists === -1)
                                            {
                                                state.carts[d].items.unshift(data.item);
                                            }
                                            else
                                            {
                                                state.carts[d].items[exists].quantity = parseFloat(state.carts[d].items[exists].quantity) + parseFloat(data.item.quantity)
                                            }
                                        }
                                    }
                                }
                            }
                            cart.addedBtnLoading = false;
                        },
                        error: function (jqXHR, textStatus, errorThrown)
                        {
                            cart.addedBtnLoading = false;
                            console.error(errorThrown)
                        }
                    });
                }
            }
        },
        removeItemFromList({commit,state,dispatch},{ cartid, itemid })
        {
            let moddedCart = {};
            for( let i = 0; i < state.carts.length; i++)
            {
                if(parseInt(state.carts[i].id) === parseInt(cartid))
                {
                    for(let i2 = 0; i2 < state.carts[i].items.length; i2++)
                    {
                        if(parseInt(state.carts[i].items[i2].id) === parseInt(itemid))
                        {
                            state.carts[i].items.splice(i2,1)
                        }
                    }
                    for(let i3 = 0; i3 < state.carts[i].cart_variations.length; i3++)
                    {
                        if(parseInt(state.carts[i].cart_variations[i3].id) === parseInt(itemid))
                        {
                            state.carts[i].cart_variations.splice(i3,1)
                        }
                    }
                    moddedCart = state.carts[i];
                }
            }
            $.ajax({
                type: 'POST',
                url: '/rest/cartsave/cart/updateCart/',
                dataType: "json",
                data: moddedCart,
                success: function (data)
                {
                    console.log(data);
                },
                error: function (jqXHR, textStatus, errorThrown)
                {
                    console.error(errorThrown)
                }
            })
        },
        updateCart({commit,state}, cart )
        {
            for(let i0 = 0; i0 < cart.items.length; i0++)
            {
                for(let i = 0; i < cart.cart_variations.length; i++)
                {
                    if(parseInt(cart.items[i0].id) === parseInt(cart.cart_variations[i].id))
                    {
                        cart.cart_variations[i].quantity = cart.items[i0].quantity
                    }
                }
            }
            for(let i2 = 0; i2 < state.carts.length; i2++)
            {
                if(parseInt(state.carts[i2].id) === parseInt(cart.id))
                {
                    state.carts[i2] = cart
                }
            }
            let cartForDb = JSON.parse(JSON.stringify(cart));
            delete cartForDb.items;

            $.ajax({
                type: 'POST',
                url: '/rest/cartsave/cart/updateCart/',
                dataType: "json",
                data: cartForDb,
                success: function (data)
                {
                    console.log(data);
                },
                error: function (jqXHR, textStatus, errorThrown)
                {
                    console.error(errorThrown)
                }
            })
        },
        deleteThisCart({commit,state},cart)
        {
            $.ajax(
                {
                    type: 'POST',
                    url: '/rest/cartsave/cart/deleteCart/',
                    data:{id:cart.id},
                    success: function (data)
                    {
                        for(let i = 0; i < state.carts.length; i++)
                        {
                            if(parseInt(cart.id) === parseInt(state.carts[i].id))
                            {
                                state.carts.splice(i,1)
                            }
                        }
                        $('#deleteList').modal('hide');
                        CeresNotification.success(ceresTranslate("CartSave::Template.notesWarenkorbgeloescht")).closeAfter(3000);
                    },
                    error: function (jqXHR, textStatus, errorThrown)
                    {
                        CeresNotification.error('jqXHR'+jqXHR+'textStatus'+textStatus+'errorTrown:'+errorThrown);
                    }
                })
        },
        updateCartData({commit,state}, cart )
        {
            for(let i2 = 0; i2 < state.carts.length; i2++)
            {
                if(parseInt(state.carts[i2].id) === parseInt(cart.id))
                {
                    state.carts[i2] = cart
                }
            }
            commit('setCarts', state.carts)

        }
    };

const getters = {};

export default
{
    state,
    mutations,
    actions,
    getters
};
